import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepTwoCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepTwoCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.memoryStepTwoCollections.data.memoryStepTwoCollections,
  (collections = []) => collections
);
const getGroupLabel = createSelector(
  (state) => state.memoryStepTwoCollections.data.memoryStepTwoGroupLabel,
  (groupLabel = '') => groupLabel
);
const getPageCount = createSelector(
  (state) => state.memoryStepTwoCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getGroupLabel,
  getHasLoaded,
  getPageCount,
};
